import { render, staticRenderFns } from "./bonus-points-modal.vue?vue&type=template&id=e61b6f3c&scoped=true&"
import script from "./bonus-points-modal.vue?vue&type=script&lang=js&"
export * from "./bonus-points-modal.vue?vue&type=script&lang=js&"
import style0 from "./bonus-points-modal.vue?vue&type=style&index=0&id=e61b6f3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61b6f3c",
  null
  
)

export default component.exports